import ServicePage from "../components/site/ServicePage";
import { getService } from "../data/site";

const TASKS = [
  "Unpacking boxes",
  "Kitchen setup",
  "Pantry setup & organization",
  "Closet setup",
  "Bathroom setup",
  "Bedroom setup",
  "Linen organization",
  "Toy organization",
  "Furniture styling",
  "Donation organization",
  "Grocery shopping",
  "Refrigerator stocking",
  "Full household setup",
];

export default function MoveIn() {
  return (
    <ServicePage
      service={getService("move-in-concierge")}
      tagline="Make your house feel like home from day one."
      intro="Moving is exhausting. Our two-person team unpacks, organizes, and styles your new home so you can walk in and exhale — beds made, pantry stocked, everything in its place."
      tasksTitle="What we handle on move-in day"
      tasks={TASKS}
      quoteHeading="Request a Quote"
    />
  );
}
